import {useLocation} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {KTIcon} from '_metronic/helpers'
import useCrispChat from 'app/Hooks/useCrispChat'
import useAuditContext from 'app/Hooks/useAuditContext'
import {useEffect, useState} from 'react'
import {doc, collection, onSnapshot} from 'firebase/firestore'
import db from 'services/firebase'

const SidebarFooter = () => {
  const location = useLocation()
  const {currentUser} = useAuth()
  const {toggleCrispChat} = useCrispChat()
  const { currentAuditContext, clearAuditContext: clearContext } = useAuditContext()
  const [daysLeft, setDaysLeft] = useState(7)

  const clearAuditContext = () => {
    clearContext()
    window.location.reload()
  }

  const isDashboard =
    location.pathname === '/dashboard' ||
    location.pathname.startsWith('/policy-library') ||
    location.pathname.startsWith('/vendor-risk') ||
    location.pathname.startsWith('/personnel-management') ||
    location.pathname.startsWith('/data-room') ||
    location.pathname.startsWith('/asset-management') ||
    location.pathname.startsWith('/risk-management') ||
    location.pathname.startsWith('/integrations') ||
    location.pathname.startsWith('/reports') ||
    location.pathname.startsWith('/tests') ||
    location.pathname.startsWith('/controls') ||
    location.pathname.startsWith('/frameworks') ||
    location.pathname.startsWith('/employees') ||
    location.pathname.startsWith('/trust-center') ||
    location.pathname.startsWith('/company-settings')

  const isOnboarding =
    location.pathname.startsWith('/training') ||
    location.pathname === '/policies' ||
    location.pathname === '/backgroundCheck'

  useEffect(() => {
    if (!currentUser?.tenantId || currentUser?.account_type !== 'Trial') {
      return
    }

    const tenantRef = doc(db, 'tenants', currentUser.tenantId)
    const employeeRef = doc(collection(tenantRef, 'employees'), currentUser.uid)

    const unsubscribe = onSnapshot(employeeRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data()
        const trialEndDate = new Date(data.trial_end_date)
        const now = new Date()
        const diffTime = trialEndDate.getTime() - now.getTime()
        const remainingDays = Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0)
        setDaysLeft(remainingDays)
      }
    })

    return () => {
      unsubscribe()
    }
  }, [currentUser])

  return (
    <div className='app-sidebar-footer flex-column-auto px-6 mb-4' id='kt_app_sidebar_footer'>
      {isDashboard && currentUser?.account_type === 'Trial' && (
        <>
          <p className='p-0 m-0 mb-1 text-white fs-7 text-center'>
            <span className='text-primary overflow-hidden text-nowrap'>{daysLeft}</span> days left
            in your trial.
          </p>
          <button
            className='btn btn-sm btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 w-100'
            title='Upgrade'
            onClick={toggleCrispChat}
          >
            <span className='btn-label'>Upgrade</span>
            <KTIcon iconName='triangle' className='btn-icon fs-2 m-0' />
          </button>
        </>
      )}
      {currentUser?.account_type === 'trust' && (
        <>
          <button
            className='btn btn-sm btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 w-100'
            title='Upgrade'
            onClick={toggleCrispChat}
          >
            <span className='btn-label'>Upgrade</span>
            <KTIcon iconName='triangle' className='btn-icon fs-2 m-0' />
          </button>
        </>
      )}
      {isOnboarding && (currentUser?.role === 'Admin' || currentUser?.role === 'Owner') && (
        <a href='/dashboard'>
          <button
            className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
            data-bs-trigger='hover'
            data-bs-dismiss-='click'
            title='Exit'
          >
            <span className='btn-label'>Exit Onboarding</span>
          </button>
        </a>
      )}
      {currentAuditContext && (
        <button
          className='btn btn-sm btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 w-100'
          title='Exit'
          onClick={clearAuditContext}
        >
          <span className='btn-label'>Exit Audit Workspace</span>
        </button>
      )}
    </div>
  )
}

export {SidebarFooter}
